import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./accordion.css";
import { handleDeleteAbstacle } from "../DSFunction";
import { updateQuantityInfo } from "../../../../Features/quantityInfo";
import { editObstacle } from "./accordionFunction";
import ObstacleLines from "./obstacleLine";
import { updateDesignParameter } from "../../../../Features/designParameter";

export default function ObstacleAccordion() {
  const [tooltip, setTooltip] = useState();

  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const designParameter = useSelector((state) => state.designParameter);
  const quantityInfo = useSelector((state) => state.quantity);

  const obstacle = roofInfo?.value?.abstacles || [];

  return (
    <div className="ac-main">
      <h1
        onClick={() =>
          dispatch(
            updateDesignParameter({
              abstacleAccordion: !designParameter.abstacleAccordion,
            })
          )
        }
      >
        <span>Select Obstacle</span>
        <i
          className={
            designParameter.abstacleAccordion
              ? `bi bi-chevron-up`
              : `bi bi-chevron-down`
          }
        ></i>
      </h1>
      {designParameter.abstacleAccordion && (
        <>
          {obstacle.length > 0 ? (
            obstacle.map((item, i) => (
              <div key={i}>
                <div className="ac-roof">
                  <div
                    className="ac-title"
                    onClick={() =>
                      dispatch(updateQuantityInfo({ abstacleNo: i }))
                    }
                  >
                    <img
                      src="../images/icons/obstacleIcon.svg"
                      alt="roofIcon"
                    ></img>
                    <span
                      style={{
                        color: quantityInfo.abstacleNo === i ? "orange" : "",
                      }}
                    >
                      Obstacle {i + 1}
                    </span>
                  </div>
                  <div className="ac-action">
                    <div className="actionBtn">
                      {tooltip === `Edit${i}` && (
                        <h4 className="warning">
                          <div className="sideArrow"></div>
                          Edit Obstacle
                        </h4>
                      )}
                      <i
                        className="bi bi-pencil-fill"
                        style={{
                          color:
                            designParameter.abstacleEdit &&
                            quantityInfo.abstacleNo === i
                              ? "orange"
                              : "",
                        }}
                        onClick={() =>
                          editObstacle({
                            i,
                            dispatch,
                            designParameter,
                            quantityInfo,
                          })
                        }
                        onMouseEnter={() => setTooltip(`Edit${i}`)}
                        onMouseLeave={() => setTooltip()}
                      ></i>
                    </div>
                    <div className="actionBtn">
                      {tooltip === `delete${i}` && (
                        <h4 className="warning obstacleTooltip">
                          <div className="sideArrow"></div>
                          Delete Obstacle
                        </h4>
                      )}
                      <i
                        className="bi bi-trash-fill trashIcon"
                        onClick={() => {
                          setTooltip();
                          handleDeleteAbstacle(
                            i,
                            obstacle,
                            dispatch,
                            quantityInfo
                          );
                        }}
                        onMouseEnter={() => setTooltip(`delete${i}`)}
                        onMouseLeave={() => setTooltip()}
                      ></i>
                    </div>
                  </div>
                </div>
                {designParameter.abstacleEdit &&
                  i === quantityInfo.abstacleNo && (
                    <ObstacleLines
                      points={obstacle.updatedPoints}
                      index={i}
                    ></ObstacleLines>
                  )}
              </div>
            ))
          ) : (
            <li>
              <img src="../images/icons/addObstacle.svg" alt="obstacle"></img>
              <span>Use this icon to draw obstacle</span>
            </li>
          )}
        </>
      )}
    </div>
  );
}
